import React, { Component, Fragment } from "react";
import {
  InputCurrency,
  Button,
  FormProvider,
  Form,
  FormContext,
  HelpTip,
  InputRadioGroup
} from "@massds/mayflower-react";
import Output from "./output";
import { toCurrency } from "../../utils";
import inputProps from "../../data/input.json";
import Reset from "../Form/Reset";

import "./index.css";

class Calculator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      dataKey: "resident"
    };
    this.inputCurrencyProps = {
      placeholder: "$0",
      format: {
        mantissa: 2,
        trimMantissa: false,
        thousandSeparated: true
      },
      inline: true,
      min: 0,
      step: 0.01,
      showButtons: false
    };
  }

  render() {
    const { submitted, dataKey } = this.state;

    return (
      <FormProvider>
        <InputRadioGroup
          defaultSelected="resident"
          inline
          name="isResident"
          onChange={({ selected }) => this.setState({ dataKey: selected })}
          outline
          required
          {...inputProps.inputRadioGroup}
        />
        <hr />
        <h2>
          <HelpTip {...inputProps.inputTaxTitle[dataKey]} {...this.helptipIframeProp} />
        </h2>
        <Form>
          {formContext => (
            <Fragment>
              {inputProps.inputTaxItems[dataKey].map(item => (
                <InputCurrency
                  key={`key_${item.value}`}
                  {...this.inputCurrencyProps}
                  labelText={item.text}
                  id={item.value}
                  name={item.value}
                  onBlur={(val, { id }) => {
                    // convert val to currency then set it to context
                    const value = toCurrency(val);
                    formContext.setValue({ id, value });
                  }}
                />
              ))}
              <Button
                type="submit"
                text={inputProps.buttonText}
                onClick={() => this.setState({ submitted: true })}
              />
            </Fragment>
          )}
        </Form>
        <FormContext.Consumer>
          {formContext => {
            const values = formContext.getValues();
            return submitted && <Output {...values} dataKey={dataKey} />;
          }}
        </FormContext.Consumer>
        <Reset />
      </FormProvider>
    );
  }
}

export default Calculator;
